import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { importProvidersFrom, APP_INITIALIZER } from '@angular/core';
import { 
  LucideAngularModule, 
  Home, CheckCircle2, CheckCircle, BadgeCheck, ImageOff, Menu, X, User, LogOut, FileImage, File, MapPin, Map, Package, Users, Calendar, Star, Heart, ArrowRight, Sparkles, Check, ChevronLeft, ChevronRight, Clock, Phone, Mail, Facebook, Twitter, Instagram, Youtube, Linkedin, Search, Filter, Languages, Award, IndianRupee, MessageSquare, Send, FileText, Building2, CreditCard, Shield, PackageX, LogIn, Info, ArrowUp, ArrowLeft, SearchX, Eye, EyeOff, CalendarCheck, UserPlus, Upload, UploadCloud, Loader2, Loader, Bold, Italic, List, ListOrdered, ShieldCheck, Trash2, Edit, Plus, Minus, AlertCircle, RefreshCw, Globe, MessageCircle, Palette, Tag, Truck, RotateCcw, ListChecks, CalendarClock, Timer, Headphones, Lock, ChevronDown, ChevronUp, ExternalLink, Bell, BellOff, SquarePen, Inbox, Share2, XCircle, Wallet, Download, Minimize, Maximize, Minimize2, Maximize2, Compass, ShieldAlert, Ambulance, Flame, Hospital, Train, Link, Hotel, Car, UserCheck, IdCard, BadgeAlert, Landmark, Navigation, ThumbsUp, ThumbsDown, BookOpen, Newspaper, Link2, Image, Video, Images, Play
} from 'lucide-angular';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import { securityInterceptor } from './app/interceptors/security.interceptor';
import { AuthService } from './app/services/auth.service';
import { LanguageService } from './app/services/language.service';
import { DbTranslationService } from './app/services/db-translation.service';

// Initialize auth state before app starts
export function initializeAuth(authService: AuthService) {
  return () => authService.initializeAuthState();
}

export function initializeDbTranslations(languageService: LanguageService, dbt: DbTranslationService) {
  return () =>
    languageService
      .initialize()
      .catch(() => {})
      .then(() => dbt.ensureAligned(languageService.getCurrentLanguage()));
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([securityInterceptor, authInterceptor]),
      withXsrfConfiguration({
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN'
      })
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeDbTranslations,
      deps: [LanguageService, DbTranslationService],
      multi: true
    },
    // Register all Lucide icons once for the entire app to avoid per-component pick/setup
    importProvidersFrom(LucideAngularModule.pick({ 
      Home, 
      CheckCircle2,
      CheckCircle,
      BadgeCheck, 
      ImageOff, 
      Menu, 
      X, 
      User, 
      Users, 
      LogOut, 
      MapPin, 
      Map,
      Package, 
      Calendar, 
      Star, 
      Heart, 
      ArrowRight, 
      Sparkles, 
      Check, 
      ChevronLeft, 
      ChevronRight, 
      Clock, 
      Phone, 
      Mail, 
      Facebook, 
      Twitter, 
      Instagram, 
      Youtube, 
      Linkedin, 
      Search, 
      Filter, 
      Languages, 
      Award, 
      IndianRupee, 
      MessageSquare, 
      Send, 
      File,
      FileText, 
      FileImage,
      Building2, 
      CreditCard, 
      Shield,
      PackageX,
      LogIn,
      Info,
      ArrowUp,
      ArrowLeft,
      SearchX,
      Eye,
      EyeOff,
      CalendarCheck,
      UserPlus,
      Upload,
      UploadCloud,
      Loader2,
      Loader,
      Bold,
      Italic,
      List,
      ListOrdered,
      ShieldCheck,
      Trash2,
      Edit,
      Plus,
      Minus,
      AlertCircle,
      RefreshCw,
      Globe,
      MessageCircle,
      Palette,
      Tag,
      Truck,
      RotateCcw,
      ListChecks,
      CalendarClock,
      Timer,
      Headphones,
      Lock,
      ChevronDown,
      ChevronUp,
      ExternalLink,
      Bell,
      BellOff,
      SquarePen,
      Inbox,
      Share2,
      XCircle,
      Wallet,
      Download,
      Minimize,
      Maximize,
      Minimize2,
      Maximize2,
      Compass,
      ShieldAlert,
      Ambulance,
      Flame,
      Hospital,
      Train,
      Link,
      Hotel,
      Car,
      UserCheck,
      IdCard,
      BadgeAlert,
      Landmark,
      Navigation,
      ThumbsUp,
      ThumbsDown,
      BookOpen,
      Newspaper,
      Link2,
      Image,
      Video,
      Images,
      Play
    })),
  ]
}).catch(err => console.error(err));
